import { render, staticRenderFns } from "./ConstanciasLaboralesComponent.vue?vue&type=template&id=ac653a2a&"
import script from "./ConstanciasLaboralesComponent.vue?vue&type=script&lang=js&"
export * from "./ConstanciasLaboralesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports